import React, { Children, FC, ReactNode } from 'react';

interface Props {
  shouldWrap: boolean;
  children: ReactNode;
}

/**
 * If @prop shouldWrap is true, simply return @prop children as is
 * If @prop shouldWrap is false, "strip" the wrapping parent element of each child of @prop children
 *
 * e.g.
 * Following:
 * <ComponentWithConditionalWrapper shouldWrap={false}>
 *  <button>
 *    <p>Text</p>
 *  </button>
 * </ComponentWithConditionalWrapper>
 * will render:
 * <p>Test</p>
 */

export const ComponentWithConditionalWrapper: FC<Props> = ({ shouldWrap, children }) => {
  if (shouldWrap) {
    return children;
  }

  const parents = Children.toArray(children);
  return parents.map((parent) => (React.isValidElement(parent) ? parent.props.children : parent));
};
